import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '../../../../store';
import { UserService } from '../../../../services/user.service';
import { AlertService } from '../../../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { BasketService } from '../../../../services/basket.service';
import { ChatService } from '../../../../services/chat.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../../../models/user/user';
import { Subscription } from 'rxjs';
import { TradeAccountRegistrationFormComponent } from '../../../../cms/trade-account-registration-form/trade-account-registration-form.component';
import { RegistrationFormComponent } from '../../components/registration-form/registration-form.component';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
    navigationHistory = [];
    referralCode = '';
    accountType = 'customer';
    regPromoCode = '';
    routing;
    isAccount:boolean = false;
    @ViewChild(RegistrationFormComponent, { read: RegistrationFormComponent }) registrationForm: RegistrationFormComponent
    @ViewChild(TradeAccountRegistrationFormComponent, { read: TradeAccountRegistrationFormComponent }) tradeRegistrationForm: TradeAccountRegistrationFormComponent

    public user: User;

    private _subscriptions: Subscription = new Subscription();

    constructor(
        private store: Store,
        private userService: UserService,
        private alertService: AlertService,
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private basketService: BasketService,
        private chatService: ChatService,
        private toastrService: ToastrService
    ) { }

    ngOnInit(): void {
        this.user = this.store.selectForLocal('user');
        this.navigationHistory = this.store.selectForLocal('navigationHistory');
        if (this.route.snapshot.params.referralCode) {
            this.referralCode = this.route.snapshot.params.referralCode;
        }

        if (this.route.snapshot.data.accountType) {
            this.accountType = this.route.snapshot.data.accountType;
        }
        if (this.route.snapshot.params.regPromoCode) {
            this.regPromoCode = this.route.snapshot.params.regPromoCode;
        }
    }

    ngOnDestroy(): void {
        this._subscriptions.unsubscribe();
    }

    registered(user) {
        this.alertService.clearMessage();
        this._subscriptions.add(this.authService.login(user.user).subscribe(
            () => {
                this.userService.getByToken().subscribe(() => {
                    const basket = this.store.selectForLocal('basket');

                    basket.customer = user.user;
                    basket.deliveryAddress = undefined;
                    basket.billingAddress = undefined;
                    this.basketService.saveBasketChanges(basket, 'modalAuth');

                    this.chatService.receiveChat();

                    if (this.navigationHistory.length) {
                        if (this.route.snapshot.queryParams.returnUrl) {
                            this.router.navigate([this.route.snapshot.queryParams.returnUrl]);
                        } else if (this.navigationHistory[0] !== '/') {
                            this.router.navigate([this.navigationHistory[0]]);
                        } else {
                            this.router.navigate(['/account', 'confirmation']);
                        }
                    } else {
                        this.router.navigate(['/account', 'confirmation']);
                    }
                });
            },
            () => {
                this.toastrService.success(
                    'Account was not created - please try at a different time.'
                );
            }
        ));
    }

    toggleRegistration(type) {
        this.isAccount = true;
        if (type === 'trade') {
            const signupFormData = this.registrationForm.form.controls
            const signupFormContact = (signupFormData.contact as FormGroup).controls
            const signupFormCompany = (signupFormData.company as FormGroup).controls

            this.tradeRegistrationForm.form.controls.user.patchValue({
                firstname: signupFormContact.firstname.value,
                surname: signupFormContact.surname.value,
                email: signupFormContact.email.value,
                mobile: signupFormContact.mobile.value,
                password: signupFormData.password.value,
                confirmPassword: signupFormData.passwordConfirm.value,
            })

        } else if (type === 'customer') {
            const tradeFormData = this.tradeRegistrationForm.form.controls
            const tradeFormContact = (tradeFormData.user as FormGroup).controls
            const tradeFormCompany = (tradeFormData.company as FormGroup).controls
            this.registrationForm.form.controls.contact.patchValue({
                firstname: tradeFormContact.firstname.value,
                surname: tradeFormContact.surname.value,
                email: tradeFormContact.email.value,
                mobile: tradeFormContact.mobile.value,
                password: tradeFormContact.password.value,
                confirmPassword: tradeFormContact.confirmPassword.value,
            })

        }
        this.accountType = type;
    }
}
